<template>
  <nav class="navbar navbar-expand-cs py-2 py-cs-0 fixed-top">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item menu-icon">
        <a class="nav-link toggle-sidebar">
          <img v-bind:src="asset('home-layout/files/menu.png')" alt="Menu Icon" />
        </a>
      </li>
    </ul>

    <!-- Left side Collapsable -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item header-search">
          <form class="form-inline my-2 my-cs-0" @submit="searchForm">
            <button class="btn btn-outline-success my-2 my-sm-0" type="submit">
              <img
                :src="asset('/home-layout/files/magnifying-glass.png')"
                alt="Search Movies"
              />
            </button>
            <input
              class="form-control mr-sm-2"
              type="search"
              id="title"
              name="title"
              placeholder=" Movie, TV Show, People "
              aria-label="Search"
              value
              v-model="search"
            />
          </form>
        </li>
        <li class="nav-item top-icon-links ml-2">
          <router-link 
            class="nav-link" 
            to="/movies" 
            active-class="active" 
            exact
            @click.native="handleClick({name: 'movies'})"
            :event="''"
          >
            <img v-bind:src="asset('/home-layout/files/video-player.png')" alt="Movies Icon" />
            <br />Movies
          </router-link>
        </li>
        <li class="nav-item top-icon-links">
          <router-link 
            class="nav-link" 
            to="/tv-shows" 
            active-class="active"
            @click.native="handleClick({name: 'tv-shows'})"
            :event="''"
          >
            <img v-bind:src="asset('/home-layout/files/smart-tv.png')" alt="TV Icon" />
            <br />TV Shows
          </router-link>
        </li>
        <li class="nav-item top-icon-links">
          <route-link 
            class="nav-link" 
            active-class="active"
            @click.native="handleClick({name: 'live.home'})"
            :event="''"
          >
            <img v-bind:src="asset('/home-layout/files/television.png')" alt="Live TV Icon" />
            <br />Live TV
          </route-link>
        </li>
        <li class="nav-item top-icon-links">
          <router-link 
            class="nav-link" 
            to="/discover/movies" 
            active-class="active"
            @click.native="handleClick({name: 'discover'})"
            :event="''"
          >
            <img v-bind:src="asset('/home-layout/files/binoculars.png')" alt="Discovery Icon" />
            <br />Discover
          </router-link>
        </li>
      </ul>
    </div>

    <!-- Center Logo -->
    <div class="nav-center">
      <router-link 
        to="/"
        @click.native="handleClick({name: 'index'})"
        :event="''"
      >
        <img v-bind:src="asset('/home-layout/files/axetv-logo.png')" alt="AXE TV" />
      </router-link>
    </div>

    <!-- Right side menu -->
    <ul class="navbar-nav ml-auto">
      <!-- <li class="nav-item d-none d-cs-inline-block">
        <span class="top-header-time" id="headerTime"></span>
        <span class="top-header-date" id="headerDate"></span>
      </li> -->
      <li class="nav-item dropdown nav-user">
        <a class="nav-link dropdown-toggle mr-0" 
          href="#" 
          id="navbarDropdown" 
          role="button" 
          data-toggle="dropdown" 
          aria-haspopup="true" 
          aria-expanded="false"
        >
          <i class="material-icons">
            person
          </i>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
          <a v-if="isAdmin"
              class="dropdown-item" 
              :href="getAdminUrl"
              active-class="active"
            >
              <i class="material-icons">dashboard</i>
              Admin Panal</a>
          <router-link 
            class="dropdown-item" 
            :to="{name: 'profile.menu-list'}" 
            active-class="active"
            @click.native="handleClick({name: 'profile.menu-list'})"
            :event="''"
          >
            <i class="material-icons">person</i>
            Profile
          </router-link>
          <router-link 
            class="dropdown-item" 
            :to="{name: 'category', params: {category: 'favorite'}}"
            active-class="active"
            @click.native="handleClick({name: 'category', params: {category: 'favorite'}})"
            :event="''"
          >
            <i class="material-icons">star</i>
            My Favorites
          </router-link>
          <router-link class="dropdown-item" 
            :to="{name: 'category', params: {category: 'watch-later'}}"
            active-class="active"
            @click.native="handleClick({name: 'category', params: {category: 'watch-later'}})"
            :event="''"
          >
            <i class="material-icons">watch_later</i>
            Watch Later
          </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#" @click.prevent="logout()">
            <i class="material-icons">lock</i>
            Logout</a>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import $ from "jquery";
import { getLocalStorage, logout, getAuthKey } from '../app/helpers';
import { httpsUrl, httpUrl } from '../app/config';

export default {

  props: {
    isLive: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      genre: null,
      avatar: '/images/1499772993.jpg',
      search: '',
      user: {},
      httpUrl,
      token: null,
    }
  },

  mounted() {

    this.user = getLocalStorage('user', {}).user || {};
    this.token = getAuthKey();

    if ($(window).width() > 991) {
      var forDate = new Date();
      setInterval(function() {
        var date = new Date();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var curHours = date.getHours();
        var hours = function() {
          if (curHours == 0) {
            return "12";
          } else if (curHours > 12) {
            return curHours - 12;
          } else {
            return curHours;
          }
        };
        var formate = date.getHours() > 11 ? "PM" : "AM";
        var curTime =
          '<span class="hours">' +
          hours() +
          '</span><span class="time-dots">:</span>' +
          minutes +
          "</span>" +
          "<small>" +
          formate +
          "</small>";
        $("#headerTime").html(curTime);
      }, 1000);

      $("#headerDate").html(
        forDate.getMonth() +
          1 +
          "/" +
          forDate.getDate() +
          "/" +
          forDate.getFullYear()
      );
    }

    $(".toggle-sidebar").click(function(e) {
      if (!$(this).hasClass("opened")) {
        $(".sidebar-menu").addClass("sidebar-opened");
        $(this).addClass("opened");
        $("body").addClass("has-sidebar");
      } else {
        $(".sidebar-menu").removeClass("sidebar-opened");
        $(this).removeClass("opened");
        $("body").removeClass("has-sidebar");
      }
    });
  },

  methods: {
    searchForm(e) {
      e.preventDefault();

      if (this.search == '') {
        return false;
      }

      const query = {
        // ...this.$route.query, 
        title: this.search,
        page: 1
      }

      this.$router.push({
        name: 'search',
        query
      });
    },

    handleClick(params) {
      if (this.isLive) {
        window.location.href = httpsUrl + '#'
          + this.$router.resolve(params).resolved.path;
      } else {
        this.$router.push(params);
      }
    },

    logout() {
      logout(this.$router);
    }
  },


  computed: {
    categoryTitle() {
      switch (this.$store.state.activeCategory) {
        case 2:
          return 'TV Shows';
        case 3:
          return 'Live Shows';
        case 4:
          return 'Documentry';
        case 5:
          return 'Sports';
        case 6:
          return 'Musicals';
        default:
          return 'Movies'
      }
    },
    isAdmin(){
      let user_data=JSON.parse(window.localStorage.getItem("axe__user"))
      let user_role_id= user_data.user.role.role_id;
      return (user_role_id===1 || user_role_id===3 || user_role_id===6)?true:false;
    },
    getAdminUrl(){
      return `${window.location.origin}/app/admin`
    }
  },

  watch: {
    '$route' (to, from) {
      this.genre = this.$route.query.genre || null;
      this.$store.commit('lastRoute', from.path);
    }
  }
};
</script>


<style lang='scss' scoped>
.toggle-sidebar {
  cursor: pointer;
}

ul.navbar-nav a.nav-link:not(.toggle-sidebar) {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,.7);
    background: rgba(255,255,255,.05);
    border-radius: 3px;
    border-left: none;
    position: relative;
    margin-right: 9px;
    padding-left: 15px !important;
    padding-right: 15px !important;
    &:hover {
      background: #C70C13;
      transition-duration: .3s;
      color: white;
    }
    &.disabled {
      background: rgb(163, 7, 12);
      transition-duration: .2s;
      color: white;
    }
}
nav.navbar .dropdown-menu {
  background-color: #292828f2;
  padding: 10px;
}

.dropdown-item {
  padding: 5px 16px;
  border-radius: 4px;
  font-size: 14px;
  text-transform: capitalize;
  margin-bottom: 7px;
  padding-left: 11px;

  i.material-icons {
    vertical-align: bottom;
    margin-right: 5px;
    font-size: 18px;
  }
}

.nav-user a#navbarDropdown {
    background: whitesmoke;
    color: black;
    padding: 5px 8px !important;
    min-width: auto;
    border-radius: 40px;
}

.nav-user a#navbarDropdown i {
    font-size: 28px;
}

.nav-user a#navbarDropdown:hover {
    color: #C70C13;
    transition: all .1s linear;
}
</style>